var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"close"}},[(_vm.isOpen)?_c('div',{class:_vm.alertClass,attrs:{"role":"alert"}},[_c('div',{staticClass:"f-alert-content mr-auto flex flex-align-items-center"},[_vm._t("default")],2),(_vm.dismissible)?_c('f-button',{attrs:{"theme":"close"},on:{"click":_vm.dismiss}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }